export enum VideoJsEvents {
    VHS_BeforeSegmentRequest = 'vhs.beforeSegmentRequest',

    Ready = 'ready',
    Progress = 'progress',
    Abort = 'abort',
    Suspend = 'suspend',
    Emptied = 'emptied',
    Stalled = 'stalled',
    Meta = 'meta',
    LoadStart = 'loadstart',
    LoadedMetadata = 'loadedmetadata',
    LoadedData = 'loadeddata',
    TimeUpdate = 'timeupdate',
    Resize = 'resize',
    VolumeChange = 'volumechange',
    TextTrackChange = 'texttrackchange',
    Dispose = 'dispose',
    SourceSet = 'sourceset',
    Play = 'play',
    Playing = 'playing',
    RateChange = 'ratechange',
    Waiting = 'waiting',
    CanPlay = 'canplay',
    CanPlayThrough = 'canplaythrough',
    Seeking = 'seeking',
    Seeked = 'seeked',

    FirstPlay = 'firstplay',
    Pause = 'pause',
    Ended = 'ended',
    FullScreenChange = 'fullscreenchange',
    TextData = 'textdata',
    DurationChange = 'durationchange',
    EnterFullWindow = 'enterFullWindow',
    ExitFullWindow = 'exitFullWindow',
    PosterChange = 'posterchange',
    ControlsEnabled = 'controlsenabled',
    ControlsDisabled = 'controlsdisabled',
    UsingNativeControls = 'usingnativecontrols',
    UsingCustomControls = 'usingcustomcontrols',
    Error = 'error',
    UserActive = 'useractive',
    UserInactive = 'userinactive',

    DuringPlaylistChange = 'duringplaylistchange',
    BeforePlaylistItem = 'beforeplaylistitem',
    PlaylistChange = 'playlistchange',
    PlaylistItem = 'playlistitem',


    QualityChange = 'qualitychange'
}
